import PropTypes from 'prop-types';

function createBetterChainableTypeChecker(validate) {
    const makeCheckType = (is) => (props, propName, componentName, location, propFullName, ...rest) => {
        const finalPropFullName = propFullName !== null ? propFullName : propName;
        const propValue = props[propName];
        if (propValue !== undefined && propValue !== null) {
            return validate(props, propName, componentName, location, finalPropFullName, ...rest);
        }
        switch (is) {
            case 'NULLABLE':
                if (propValue === null) {
                    return null;
                }
                return new Error(`The ${location} \`${finalPropFullName}\` is marked as nullable in ` +
                    `\`${componentName}\`, but its value is \`undefined\`.`);
            case 'REQUIRED':
                if (propValue === null) {
                    return new Error(`The ${location} \`${finalPropFullName}\` is marked as required ` +
                        `in \`${componentName}\`, but its value is \`null\`.`);
                }
                return new Error(`The ${location} \`${finalPropFullName}\` is marked as required in ` +
                    `\`${componentName}\`, but its value is \`undefined\`.`);
            case 'UNNULLABLE':
                if (propValue === null) {
                    return new Error(`The ${location} \`${finalPropFullName}\` is marked as NOT null ` +
                        `in \`${componentName}\`, but its value is \`null\`.`);
                }
                return null;
            default:
                return null;
        }
    };
    const chainedCheckType = Object.assign(makeCheckType(), {
        isOptionalButNotNull: makeCheckType('UNNULLABLE'),
        isRequired: makeCheckType('REQUIRED'),
        isRequiredButNullable: makeCheckType('NULLABLE'),
    });
    return chainedCheckType;
}

const array = createBetterChainableTypeChecker(PropTypes.array);
const bool = createBetterChainableTypeChecker(PropTypes.bool);
const func = createBetterChainableTypeChecker(PropTypes.func);
const number = createBetterChainableTypeChecker(PropTypes.number);
const object = createBetterChainableTypeChecker(PropTypes.object);
const string = createBetterChainableTypeChecker(PropTypes.string);
const symbol = createBetterChainableTypeChecker(PropTypes.symbol);
const any = createBetterChainableTypeChecker(PropTypes.any);
const arrayOf = type => createBetterChainableTypeChecker(PropTypes.arrayOf(type));
const element = createBetterChainableTypeChecker(PropTypes.element);
const elementType = createBetterChainableTypeChecker(PropTypes.elementType);
const instanceOf = expectedClass => createBetterChainableTypeChecker(PropTypes.instanceOf(expectedClass));
const node = createBetterChainableTypeChecker(PropTypes.node);
const objectOf = type => createBetterChainableTypeChecker(PropTypes.objectOf(type));
const oneOf = types => createBetterChainableTypeChecker(PropTypes.oneOf(types));
const oneOfType = type => createBetterChainableTypeChecker(PropTypes.oneOfType(type));
const shape = type => createBetterChainableTypeChecker(PropTypes.shape(type));
const exact = type => createBetterChainableTypeChecker(PropTypes.exact(type));
const BetterPropTypes = {
    any,
    array,
    arrayOf,
    bool,
    element,
    elementType,
    exact,
    func,
    instanceOf,
    node,
    number,
    object,
    objectOf,
    oneOf,
    oneOfType,
    shape,
    string,
    symbol,
};

export { BetterPropTypes as default };
//# sourceMappingURL=index.js.map
